import { create } from 'zustand';

type ChannelSessionState = {
  selectedChannelId: string | null;
};

type ChannelSessionActions = {
  setSelectedChannelId: (channelId: string | null) => void;
};

type ChannelSessionStore = ChannelSessionState & ChannelSessionActions;

export const useChannelSessionStore = create<ChannelSessionStore>(set => ({
  selectedChannelId: null,
  setSelectedChannelId: channelId => set({ selectedChannelId: channelId }),
}));

export const selectSelectedChannelId = (): string | null => useChannelSessionStore.getState().selectedChannelId;
